import React, { useState, useEffect } from "react";
import { Modal, Switch } from "antd";
import { TablaCompleta } from "../tablas/tabla_simple";
import axios from "axios";
import { HeadersAuth } from "../funciones_utiles";


export const ModalApp = ({
  open,
  onCancel,
}) => {
  const [estado, setEstado] = useState([]);
  const [estadoAndroid, setEstadoAndroid] = useState([]);
  const [estadoIos, setEstadoIos] = useState([]);

  useEffect(() => {
    fetchEstadoApp();
  }, [open]);

  const fetchEstadoApp = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_DOMINIO}/estado-web`, HeadersAuth);
      setEstado(response.data);
      // console.log("response", response.data)
    } catch (error) {
      console.error("error", error)
    }
  };

  const editarEstadoApp = async (plataforma, estado) => {
		try {
      // console.log("lo que s envía", plataforma, estado)
			const response = await axios.put(`${process.env.REACT_APP_DOMINIO}/editar-estado-app`,
				{
					plataforma,
					estado: estado,
				},
				HeadersAuth
			);

			if (response.status == 200) {
				fetchEstadoApp();
			}

		} catch (error) {
			console.error("Error al cambiar el estado de la app:", error);
		}
	}

  const elScroll = { x: 0 };
  const columns = [
    {
      title: "Plataforma",
      dataIndex: "plataforma",
      key: "plataforma",
      render: (plataforma) => (plataforma === "android" ? "Android" : "iOS"),
    },
    {
      title: "Estado",
      dataIndex: "activo",
      key: "activo",
      render: (activo) => (activo ? "Activa" : "En mantenimiento"),
    },
    {
      title: "Acciones",
      key: "acciones",
      render: (_, record) => (
        <Switch
          checked={record.activo}
          style={{
            backgroundColor: record.activo ? "#233463" : "#BA1721",
          }}
          onChange={() =>
						editarEstadoApp(
						record.plataforma,
						!record.activo
						)
					}
        />
      ),
    },
  ];


  return (
    <Modal
      title="Gestor de la app"
      open={open}
      onCancel={onCancel}
      footer={null}
    >
      <TablaCompleta 
        elScroll={elScroll}
        columns={columns}
        fetchDatos={ 
          estado
            ? [
                {
                  plataforma: "android",
                  activo: estado.estadoAndroid?.estado,
                },
                {
                  plataforma: "ios",
                  activo: estado.estadoIos?.estado,
                },
              ]
            : []
        }
        mostrarBoton={false}
        mostrarBuscador={false}
      />
    </Modal>
  )
}